
export const PredefinedStrategies = {
    conservative: 'conservative_v2',
    moderate: 'moderate_v2',
};